import Glide from '@glidejs/glide';

export default (count = 5) => ({
  carousel: null,
  count: count,
  get activeSlide() {
    return this.carousel.index;
  },
  prev() {
    this.carousel.go('<');
  },
  next() {
    this.carousel.go('>');
  },

  setPadding() {},

  init() {
    this.setPadding();
    this.carousel = new Glide(this.$refs.carousel, {
      type: 'carousel',
      perView: this.count,
      autoplay: 5000,
      focusAt: 0,
      breakpoints: {
        640: {
          perView: 2,
        },
      },
    });
    this.carousel.mount();
  },
});
